import { ReoIcon as WebUIIcon } from '@reolink-web/ui';
import { ReoIcon } from '@/deps/basic';
import React, { useMemo, useRef, useState } from 'react';
import type { ITagProps } from '../IComponent';
import '../index.less';
import handleUbbTextWithV2 from '@/utils/shared/handleUbbTextWithV2';
import classNames from 'classnames';
import { useIsomorphicLayoutEffect } from '@/utils/hooks/useIsomorphicLayoutEffect';

const Tag: React.FC<ITagProps> = (props) => {

    const {
        top,
        left,
        screenWidth,
        children,
        tagName,
        onClick,
        showBubble,
        onBubbleClick,
    } = props;

    const positionStyle = React.useMemo<React.CSSProperties>(() => ({
        top: top,
        left: left
    }), [left, top]);

    const textDom = useMemo(() => {
        if (screenWidth >= 768) {
            return (
                <span className={ 'reolink-home-tag-text' }>
                    {
                        children ?? <span dangerouslySetInnerHTML={{ __html: handleUbbTextWithV2(tagName, { mode: 'inline' }) }} />
                    }
                </span>
            );
        }
        return null;
    }, [children, screenWidth, tagName]);

    const iconDom = useMemo(() => {
        if (screenWidth >= 1280) {
            return (
                <div className='reolink-home-tag-icon'>
                    <WebUIIcon
                        className='reolink-home-tag-icon-content'
                        width={ '18px' }
                        name={ 'icon-new-arrow-right' }
                    />
                </div>
            );
        }
        else if (screenWidth < 768) {
            return (
                <div
                    className={ classNames('reolink-home-tag-dot', { 'reolink-home-tag-dot--active': showBubble }) }
                >
                    <span
                        className={ classNames('reolink-home-tag-dot-inner', { 'reolink-home-tag-dot-inner--active': showBubble }) }
                    />
                </div>
            );
        }
        return null;
    }, [screenWidth, showBubble]);

    const bubbleRef = useRef<HTMLDivElement>(null);
    const tagRef = useRef<HTMLDivElement>(null);
    const [bubbleStyle, setBubbleStyle] = useState<React.CSSProperties>({});

    useIsomorphicLayoutEffect(() => {
        if (!(screenWidth < 768 && showBubble)) return;
        const bubble = bubbleRef.current;
        const tag = tagRef.current;
        if (!bubble || !tag) return;
        const bubbleRect = bubble.getBoundingClientRect();
        const tagRect = tag.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const style: React.CSSProperties = { top: '100%', marginTop: 8, left: '50%', transform: 'translateX(-50%)', maxWidth: 'calc(100vw - 16px)' };
        // 计算bubble左侧和右侧是否超出
        const bubbleLeft = tagRect.left + tagRect.width / 2 - bubbleRect.width / 2;
        const bubbleRight = bubbleLeft + bubbleRect.width;
        if (bubbleLeft < 8) {
            style.left = 0;
            style.transform = 'none';
        }
        else if (bubbleRight > viewportWidth - 8) {
            style.left = 'auto';
            style.right = 0;
            style.transform = 'none';
        }
        setBubbleStyle(style);
    }, [screenWidth, showBubble]);

    return (
        <div
            ref={ tagRef }
            style={ positionStyle }
            className={ classNames('reolink-home-tag', { 'reolink-home-tag-active': showBubble }) }
            onClick={ onClick }
        >
            { textDom }
            { iconDom }
            {/* 气泡，仅在移动端显示 */}
            {screenWidth < 768 && showBubble ? (
                <div
                    ref={ bubbleRef }
                    className="reolink-home-tag-bubble"
                    style={ bubbleStyle }
                    onClick={ e => {
                        e.stopPropagation();
                        onBubbleClick?.();
                    } }
                >
                    <span className="reolink-home-tag-bubble-text">{tagName}</span>
                    <ReoIcon
                        name="icon-co_right"
                        className="reolink-home-tag-bubble-icon"
                        width="18px"
                    />
                </div>
            ) : null}
        </div>
    );
};

export default Tag;
